import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import StudentPerformanceAnalytics from "PerformanceAnalytics/routes/StudentPerformanceAnalytics";
export default store => {
  return {
    path: ":classId",
    component: withAsyncRouteLoading(
      () =>
        Promise.all([
          import(/* webpackChunkName: "class-overview" */ "./components"),
        ]).then(([importedModule0]) => {
          const component = importedModule0.default;
          return component;
        })
      // .catch(err => {
      //   throw err;
      // })
    ),
    childRoutes: [StudentPerformanceAnalytics(store)],
  };
};
